module.exports = __webpack_public_path__ + "img/btn-walk.50182836.png";